<template>
  <div :class="bandWrapperClass" v-if="tagSearchList.length">
    <template v-if="multisectionList.length > 0">
      <div v-for="(sectionInfo, index) in multisectionList" :key="sectionInfo.title + index">
        <DynamicSectionLoader :section-info="sectionInfo" :key="sectionInfo.title" :tag-search-keyword-list="tagSearchList"></DynamicSectionLoader>
      </div>
    </template>
    <div v-else class="empty-cell-list">
      <div class="attention-mark-area">
        <EmptyIcon />
      </div>
      <div class="text-area">
        선택한 태그 검색결과가 없어요.<br/>
        다른 태그를 선택해보세요.
      </div>
    </div>
  </div>
</template>

<script>
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import { get } from 'lodash'
import { PATH_NAME_SEARCH_TAG, PATH_NAME_SEARCH_TAG_GROUP } from '@/common/router.const'
export default {
  name: 'TagSearchResultBandView',
  components: {
    EmptyIcon,
    DynamicSectionLoader
  },
  props: {
    tagSearchList: {
      type: Array
    },
    multisectionList: {
      type: Array
    },
    searchCategory: {
      type: String
    },
    searchType: {
      type: String
    },
    mType: {
      type: String
    }
  },
  computed: {
    bandWrapperClass () {
      let className = 'search-wrapper'
      if (get(this.$route, 'name', '') === PATH_NAME_SEARCH_TAG_GROUP) {
        className += ' with-tag-list'
      } else if (get(this.$route, 'name', '') === PATH_NAME_SEARCH_TAG) {
        className += ' with-tag-list with-tag-refresh'
      }
      return className
    }
  }
}
</script>
